import React from 'react'
import { FormGroup, Col, InputGroup, InputGroupAddon, Button, Input } from 'reactstrap'

export default function NodeSearchBar (props) {
  return (
    <FormGroup row>
      <Col md="12">
        <InputGroup>
          <InputGroupAddon addonType='prepend'>
            <Button disabled color="secondary"><i className="fa fa-search"></i> Search</Button>
          </InputGroupAddon>
          <Input 
            type="text" 
            id="search" 
            name="search" 
            placeholder="Search for a node"
            value={props.search}
            onChange={(e) => props.handleChange(e)}
          />
        </InputGroup>
      </Col>
    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/KnowledgeMap/NodeSearchBar.js